// src/components/layout/DataTable.jsx
import React from 'react';
import { Pagination } from '@components';

export function DataTable({ 
  columns,      // [{ key: 'id', label: '아이디', width: 'w-20', align: 'text-center' }, ...]
  page,         // { rows: [], total, pageNum, pageSize }
  renderRow,    // (row, index) => <tr key={row.id}>...</tr>
  emptyMessage = "조회된 데이터가 없습니다.",
  onPageChange,
  itemName = "데이터"
}) {
  return (
    <div className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm w-full">
      <div className="overflow-x-auto">
        <table className="w-full text-left text-sm whitespace-nowrap">
          
          <thead className="bg-slate-50 text-xs font-semibold uppercase text-slate-500 border-b border-slate-200">
            <tr>
              {columns.map((col, idx) => (
                <th key={idx} className={`px-6 py-4 ${col.width || ''} ${col.align || ''} ${col.className || ''}`}>
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100">
            {!page.rows || page.rows.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className="py-16 text-center text-slate-500">
                  {emptyMessage}
                </td>
              </tr>
            ) : (
              page.rows.map((row, index) => renderRow(row, index))
            )}
          </tbody>

        </table>
      </div>
      
      <Pagination 
        total={page.total} 
        pageNum={page.pageNum} 
        pageSize={page.pageSize} 
        itemName={itemName} 
        onChange={onPageChange} 
      />
    </div>
  );
}